import {
  useRef,
  cloneElement,
  isValidElement,
  memo,
  useEffect,
  useCallback
} from 'react'
import { UPLOAD_TYPES } from 'consts/uploadTypes'
import { IProps } from './types'

const MediaUploadButton = ({
  children,
  acceptType = 'visualMedia',
  handleFilesUpload,
  refTrigger
}: IProps & {
  refTrigger?: { current: { triggerUpload: () => void } | null }
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const onUploadTrigger = useCallback(() => inputRef.current?.click(), [])

  // Expose triggerUpload function through refTrigger if provided
  useEffect(() => {
    if (refTrigger) {
      refTrigger.current = {
        triggerUpload: onUploadTrigger
      }
    }
  }, [refTrigger, onUploadTrigger])

  const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (!files || files.length === 0) return

    await handleFilesUpload(files)
    event.target.value = ''
  }

  const acceptString = UPLOAD_TYPES[acceptType].join(',')

  return (
    <>
      <input
        type="file"
        accept={acceptString}
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={onChange}
        multiple
      />
      {children &&
        (isValidElement(children)
          ? cloneElement(children, { onClick: onUploadTrigger })
          : children)}
    </>
  )
}

export default memo(MediaUploadButton)
